import type { ReactNode } from 'react';

export const SEAL_TONES = {
  maroon: 'bg-maroon text-champagne ring-gold/60',
  olive: 'bg-olive text-champagne ring-champagne/40',
  pink: 'bg-pink text-maroon-deep ring-maroon/25',
  gold: 'bg-gold text-maroon-deep ring-maroon/25',
  charcoal: 'bg-charcoal text-champagne ring-gold/50',
} as const;

export type SealTone = keyof typeof SEAL_TONES;

/** Round sticker seal from the board, used for Sold out / % off / Featured. */
export function Seal({
  tone = 'maroon',
  size = 'md',
  className = '',
  children,
}: {
  tone?: SealTone;
  size?: 'sm' | 'md';
  className?: string;
  children: ReactNode;
}) {
  const dims = size === 'sm' ? 'size-14 text-[0.6rem]' : 'size-[4.5rem] text-[0.68rem]';
  return (
    <span
      className={`grid shrink-0 place-items-center rounded-full text-center leading-tight font-medium tracking-[0.12em] uppercase shadow-(--shadow-seal) ring-1 ring-inset ${dims} ${SEAL_TONES[tone]} ${className}`}
    >
      <span className="px-1.5">{children}</span>
    </span>
  );
}
